module.exports = __webpack_public_path__ + "img/banner-wbsc.fdd7ea66.png";